<template>
  <div :id="myId" :style="cssStyle"></div>
</template>
<script>
  let id = "emrIdeJs";
  if (!document.getElementById(id)) {
    let js = document.createElement("script");
    js.type = "text/javascript";
    js.src = "https://emr.sunwayhis.cn/mreditor/web-apps/apps/api/documents/api.js";
    js.setAttribute("editorserver", "/mreditor");
    js.setAttribute("id", id);
    let s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(js, s);
  }

  export default {
    props: {
      bin: String,
      cssStyle: { type: String, default: () => "height: 40rem;border: 1px solid #EBEEF5" },
    },
    data() {
      return {
        enitor: null,
        myId: "myEditor",
      };
    },
    mounted() {
      this.myId = `editor${Math.floor(Math.random() * 1000)}`;
      setTimeout(() => {
        this.editor = new NsoOffice();

        let oRet = this.editor.CreateControl(this.myId);
        if (oRet.id) {
          this.$message.error("编辑器创建失败！");
          console.log("编辑器创建失败！", oRet);
        } else {
          this.editor.SetToolBarsVisible("All", false);
          this.editor.SetRPropWindowVisible(false);
          this.editor.SetLeftPanelVisible(false);
          this.editor.InitEvents();
          this.editor.NsoFileOpenCompleted = () => {
            console.log("打开了");
          };
          this.open();
        }
      }, 1000);
    },
    methods: {
      open() {
        setTimeout(() => {
          let oRet = this.editor.OpenFile(atob(this.bin), 2, 0, { ShowSdtBorders: false });
          if (oRet.id) {
            console.log("文件打开失败", oRet);
          }
          console.log("文件打开", oRet);
        }, 1000);
      },
    },
  };
</script>
